<!--
 * @Author: Gaho
 * @Date: 2024-03-19 14:22:20
 * @LastEditors: Gaho
 * @LastEditTime: 2024-03-19 15:21:41
 * @Description: 
-->
<template>
    <div class="relative py-4">
        <img src="./img/limbo_result.webp" alt="">
        <p>{{ history.roll_number }}x</p>
    </div>
</template>
<script setup lang="ts">
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
})

</script>
<style lang="scss" scoped>
img {
    border-radius: 5px;
    display: block;
    height: auto;
    user-select: none;
    width: 100%;
}
p {
    color: #fff;
    font-size: 45px;
    font-weight: 900;
    left: 50%;
    line-height: 1;
    margin: 0;
    position: absolute;
    top: 40%;
    transform: translate(-50%,-50%);
    white-space: nowrap;
}
</style>